import React from 'react'

import Nav from '../Nav/Nav'

import './StaticScene.css'

const StaticScene = ({ children }) => (
  <div className="StaticScene">
    <Nav slim={true} />
    <div className="container">
      <div className="row">
        <div className="col">{children}</div>
      </div>
    </div>
  </div>
)

export default StaticScene



// WEBPACK FOOTER //
// ./src/components/StaticScene/StaticScene.js